import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ICountry } from './../interfaces/icountry';
import { IUser } from '../interfaces/iuser';
import { ISortableColumns } from '../interfaces/isortable-columns';

// needs to support multiple interfaces
export type SortColumn = keyof ISortableColumns | '';
export type SortColumnUser = keyof IUser | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { asc: 'desc', desc: '', '': 'asc' };

export interface SortEvent {
	column: SortColumn;
	direction: SortDirection;
}

@Directive({
	selector: 'th[sortable]',
	standalone: true,
	host: {
		'[class.asc]': 'direction === "asc"',
		'[class.desc]': 'direction === "desc"',
		'(click)': 'rotate()',
	},
})
export class NgbdSortableHeader {
	@Input() sortable: SortColumn  = '';
	@Input() direction: SortDirection = '';
	@Output() sort = new EventEmitter<SortEvent>();

	rotate() {
		this.direction = rotate[this.direction];
		this.sort.emit({ column: this.sortable, direction: this.direction });
	}
}
